import React, { useState } from 'react';
import TabComponent from '../../components/TabComponent';
import DepositIndex from './Deposit';
import DepositTableIndex from './DepositTable';
import DepositPaymentApprovalIndex from './DepositPaymentApproval';

export const DepositFormIndex = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const tabOptions = [
    {
      to: '',
      label: 'Deposit Form',
      index: 0,
    },
    {
      to: '',
      label: 'Deposit Table',
      index: 1,
    },
    {
      to: '',
      label: 'Deposit payment Approvals',
      index: 2,
    },
  ];

  return (
    <div className="transactions__page">
      <h3>Deposits</h3>
      <div className="">
        <TabComponent
          taboptions={tabOptions}
          selectedTab={selectedIndex}
          setSelectedTab={setSelectedIndex}
        />
      </div>
      <div className="main__container">
        {selectedIndex === 0 && <DepositIndex />}
        {selectedIndex === 1 && <DepositTableIndex />}
        {selectedIndex === 2 && <DepositPaymentApprovalIndex />}
      </div>
    </div>
  );
};
